import {
  AkamaiError,
  BotChallengeError,
  ParsingError,
  ServerError
} from './errors';
//import { newRelicClient } from '@api/analytics';

type BaseHttpHeaders = {
  'Content-Type': 'application/json';
  [key: string]: string;
};

export type HttpHeaders = BaseHttpHeaders;

export class Http {
  private headers: Headers;
  private url: string;
  private options: RequestInit = {
    credentials: 'include',
    mode: 'same-origin',
    cache: 'no-cache',
    method: 'GET'
  };
  private response: Response | undefined;
  private request: Request | undefined;

  constructor(
    url: string,
    options: RequestInit,
    headers: HttpHeaders = { 'Content-Type': 'application/json' }
  ) {
    this.url = url;
    this.options = { ...this.options, ...options };
    this.headers = new Headers(headers);
  }

  get status(): number | null {
    return this.response ? this.response.status : null;
  }

  get ok(): boolean {
    return this.response ? this.response.ok : false;
  }

  async json<T>(): Promise<T> {
    if (!this.response) {
      throw new Error('invalid_call');
    }

    const parsedResponse = await this.response.json().catch(async () => {
      throw new ParsingError(this.response?.body?.toString() || '', this.url);
    });

    if (parsedResponse) {
      return parsedResponse;
    }

    throw new ServerError({error_id:'', errors:[{message: parsedResponse.errors, code:parsedResponse.invalidIds}]}, this.response.status, this.url);
  }

  async exec(): Promise<Http> {
    if (this.request) {
      return this;
    }

    //const nrInteraction = newRelicClient.interaction();
    //nrInteraction.save();

    this.response = await fetch(this.url, {
      ...this.options,
      headers: this.headers
    });

    const akamaiHeader = this.response.headers.get('x-reference-error');
    if (akamaiHeader) throw new AkamaiError(akamaiHeader);

    // eslint-disable-next-line eqeqeq
    if (this.response.status == 428) {
      throw new BotChallengeError();
    }

    return this;
  }
}
